module.exports = __webpack_public_path__ + "img/femaleGesture.28ead166.png";